import { Award, BicepsFlexed, Drama, Frown, ThumbsDown } from 'lucide-react';
import React from 'react';

function DiscountLegend() {
  // Map each discount type to its corresponding style properties
  const typeMapping: Record<
    string,
    {
      bg: string;
      text: string;
      icon: React.ReactNode;
      explain: string;
    }
  > = {
    best: {
      bg: 'bg-emerald-50 dark:bg-emerald-950/50',
      text: 'text-emerald-700 dark:text-emerald-300',
      icon: <Award className="h-4 w-4" />,
      explain: 'ممتاز',
    },
    only: {
      bg: 'bg-blue-50 dark:bg-blue-950/50',
      text: 'text-indigo-700 dark:text-indigo-300',
      icon: <BicepsFlexed className="h-4 w-4" />,
      explain: 'وحيد',
    },
    static: {
      bg: 'bg-purple-50 dark:bg-purple-950/50',
      text: 'text-fuchsia-700 dark:text-fuchsia-300',
      icon: <Drama className="h-4 w-4" />,
      explain: 'ثابت',
    },
    accept: {
      bg: 'bg-gray-50 dark:bg-gray-800/50',
      text: 'text-gray-600 dark:text-gray-300',
      icon: <Frown className="h-4 w-4" />,
      explain: 'مقبول',
    },
    bad: {
      bg: 'bg-red-50 dark:bg-red-950/50',
      text: 'text-red-600 dark:text-red-300',
      icon: <ThumbsDown className="h-4 w-4" />,
      explain: 'ضعيف',
    },
  };

  return (
    <div className="inline-flex rounded-md border border-gray-200 bg-white/80 px-0.5 py-0.5 shadow-sm dark:border-gray-800 dark:bg-gray-900/80">
      {Object.entries(typeMapping).map(([key, value]) => (
        <div
          key={key}
          className={`flex items-center gap-1 rounded-md px-1.5 py-0.5 ${value.bg} `}
        >
          <div
            className={`flex h-6 w-6 flex-shrink-0 items-center justify-center ${value.text} `}
          >
            {value.icon}
          </div>
          <span className={`text-xs font-medium ${value.text}`}>
            {value.explain}
          </span>
        </div>
      ))}
    </div>
  );
}

export default DiscountLegend;
